var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "route" }, [
    _c("h2", [_vm._v(_vm._s(_vm.name))]),
    _vm._v(" "),
    _vm.data.length
      ? _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.displayNextTrip()))]),
          _vm._v(" "),
          _c("p", [_vm._v("Upcoming departures:")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.data, function(trip) {
              return _c("li", [_vm._v(_vm._s(_vm.displayTrip(trip)))])
            })
          )
        ])
      : _c("div", [_c("p", [_vm._v("No data available")])])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ede25f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ede25f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/route.vue
// module id = 353
// module chunks = 0